import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import type { TabFeatureFlags } from '../../contracts';
import { sharedSelectors } from '../../shared/ducks';
import type { RootState } from '../../store/types';

type OwnProps = {
  Component: React.ComponentType;
  featureFlag?: string | null;
  path: string;
};

type StateProps = {
  tabFeatureFlags: TabFeatureFlags;
};

function RouteWithFeatureFlag({
  tabFeatureFlags,
  path,
  Component,
  featureFlag
}: OwnProps & StateProps) {
  const shouldShowRoute = featureFlag
    ? tabFeatureFlags[featureFlag as keyof TabFeatureFlags]
    : true;
  if (!shouldShowRoute) return null;

  return <Route path={path} component={Component} />;
}

const mapStateToProps = (state: RootState) => ({
  tabFeatureFlags: sharedSelectors.getTabFeatureFlags(state)
});

export default connect(mapStateToProps)(RouteWithFeatureFlag);
